import { render, staticRenderFns } from "./cChart.vue?vue&type=template&id=51580977&scoped=true&"
import script from "./cChart.vue?vue&type=script&lang=js&"
export * from "./cChart.vue?vue&type=script&lang=js&"
import style0 from "./cChart.vue?vue&type=style&index=0&id=51580977&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51580977",
  null
  
)

export default component.exports